import { FormValues } from "./types";

export const DEFAULT_FORM_VALUES: FormValues = {
  first_name: '',
  last_name: '',
  email: '',
  language: 'nl',
  role_id: '',
  avatar: null
}